import {Text, View, Image} from '@react-pdf/renderer';
import React from 'react';
import {styles} from '../styles';

import sleipnerBackground from 'assets/pdf/sleipner-pdf-bg.png';
import {
	Hr,
	MultiLineText,
	PageWithHeaderAndFooter,
	Row,
	RowItem,
	TableRow,
	ValueTitle,
} from '../documentComponents';
import {yellow} from 'styles/constants';
import {baseFormatClean} from 'components/ModelDetailsTable';
import globe from 'assets/pdf/globe.png';
import hybrid from 'assets/pdf/hybrid.png';

export const EnvironmentalEffectsPage = ({customer, showellUser, calculatedValues}) => {
	const Chart = ({calculatedValues}) => {
		let withAmount = Math.floor(
			calculatedValues['CO2 produced with Sleipner in year (tonnes)'],
		);
		let withoutAmount = Math.floor(
			calculatedValues['CO2 produced without Sleipner in year (tonnes)'],
		);
		let a = withoutAmount - withAmount;
		let stepSize = a / 5;
		let steps = [withAmount];

		for (let i = 1; i < 6; i++) {
			let n = i * stepSize;
			steps.push(Math.round(n / 50) * 50);
		}
		steps.push(withoutAmount);

		return (
			<>
				<View
					style={{
						height: 20,
						width: '16%',
						backgroundColor: '#fff',
						marginBottom: 5,
						borderWidth: 1,
						borderColor: '#000',
					}}
				>
					<Text
						style={{
							color: '#000',
							position: 'relative',
							top: 1,
							left: 5,
							fontWeight: 600,
						}}
					>
						With Sleipner
					</Text>
				</View>
				<View style={{height: 20, width: 500, backgroundColor: '#000'}}>
					<Text
						style={{
							color: yellow,
							position: 'relative',
							top: 1,
							left: 5,
							fontWeight: 600,
						}}
					>
						Without Sleipner
					</Text>
				</View>

				<View
					style={{
						borderTop: 1,
						borderColor: '#000',
						marginTop: 4,
						display: 'flex',
						flexDirection: 'row',
						width: '100%',
						justifyContent: 'space-between',
						paddingLeft: 60,
						paddingRight: 20,
					}}
				>
					{steps.map((s, index) => (
						<Text key={index}>{s}</Text>
					))}
				</View>
			</>
		);
	};

	const savings = {
		timeSpentTravelling:
			calculatedValues['Annual time spent travelling without Sleipner (h)'] -
			calculatedValues['Annual time spent travelling with Sleipner (h)'],
		fuelConsumption:
			calculatedValues['Fuel consumption without sleipner in time spent traveling'] -
			calculatedValues['Fuel consumption with sleipner in time spent traveling'],
		co2:
			calculatedValues[
				'CO2 produced without Sleipner in time spent travelling (tonnes)'
			] -
			calculatedValues['CO2 produced with Sleipner in time spent travelling (tonnes)'],
	};
	return (
		<PageWithHeaderAndFooter
			headerBackgroundImageUrl={sleipnerBackground}
			footerBackgroundImageUrl={sleipnerBackground}
			customer={customer}
			pageTitle="Environmental Benefits"
			showellUser={showellUser}
		>
			<View style={styles.layout.containerHorizontal}>
				<Row styleProps={{marginBottom: 20}}>
					<RowItem>
						<ValueTitle>Working Hours</ValueTitle>
						<MultiLineText>
							When travelling on tracks, excavators operate in maximum load mode. With
							Sleipner dollies, the excavator operates in low load mode during the entire
							travel time, resulting in a dramatic reduction in fuel consumption.
						</MultiLineText>
					</RowItem>
				</Row>

				<Row>
					<RowItem width="30%">
						<Text> </Text>
					</RowItem>
					<RowItem width="23%">
						<Text style={{fontWeight: 600, textTransform: 'uppercase'}}>Without</Text>
					</RowItem>
					<RowItem width="23%">
						<Text style={{fontWeight: 600, textTransform: 'uppercase'}}>
							With Sleipner
						</Text>
					</RowItem>
					<RowItem width="23%">
						<Text style={{fontWeight: 600, textTransform: 'uppercase'}}>
							Savings annually
						</Text>
					</RowItem>
				</Row>

				<TableRow
					title="Time spent travelling"
					values={[
						calculatedValues['Annual time spent travelling without Sleipner (h)'] + ' h',
						calculatedValues['Annual time spent travelling with Sleipner (h)'] + ' h',
						savings.timeSpentTravelling + ' h',
					]}
				></TableRow>
				<TableRow
					title="Fuel Consumption"
					values={[
						baseFormatClean(
							calculatedValues[
								'Fuel consumption without sleipner in time spent traveling'
							],
						) + ' litres',
						baseFormatClean(
							calculatedValues['Fuel consumption with sleipner in time spent traveling'],
						) + ' litres',
						baseFormatClean(savings.fuelConsumption) + ' litres',
					]}
				></TableRow>
				<TableRow
					title="Tonnes of CO2"
					values={[
						calculatedValues[
							'CO2 produced without Sleipner in time spent travelling (tonnes)'
						] + ' tonnes',
						calculatedValues[
							'CO2 produced with Sleipner in time spent travelling (tonnes)'
						] + ' tonnes',
						savings.co2.toFixed(2) + ' tonnes',
					]}
				></TableRow>

				<Row styleProps={{marginTop: 20, marginBottom: 20}}>
					<RowItem>
						<ValueTitle>Tonnes of CO2 per year</ValueTitle>
						<Chart calculatedValues={calculatedValues}></Chart>
					</RowItem>
				</Row>

				<Hr></Hr>

				<Row>
					<RowItem>
						<ValueTitle>Sustainability</ValueTitle>
						<MultiLineText styleProps={{marginBottom: 10}}>
							CO2 emissions while travelling are reduced by up to 80%. With the Sleipner
							dollies, your organisation can take one giant leap forward, not just in
							productivity but also in terms of sustainability.
						</MultiLineText>
						<MultiLineText>
							The Sleipner dollies not only help you reduce your carbon footprint, they
							also reduce the risk of accidents during maintenance, such as oil spills, by
							allowing the excavator to be transported to the workshop without losing
							considerable amounts of production time.
						</MultiLineText>
					</RowItem>
				</Row>

				<View
					style={{
						backgroundColor: '#666',
						paddingHorizontal: 15,
						paddingVertical: 10,
						borderRadius: 3,
						marginTop: 15,
					}}
				>
					<Text style={[styles.text.yellow, {fontWeight: 600, marginBottom: 5}]}>
						Fun Fact!
					</Text>
					<Row
						styleProps={{
							justifyContent: 'space-between',
							color: yellow,
							alignItems: 'center',
						}}
					>
						<RowItem styleProps={{flex: 1, flexDirection: 'row', alignItems: 'center'}}>
							<Image
								src={hybrid}
								style={{marginRight: '15px', width: '25px', height: '25px'}}
							/>
							<Text>Lifetime CO2 kilometers compared to low emission hybrid cars</Text>
						</RowItem>
						<RowItem width="auto">
							<Text style={{textAlign: 'right', fontWeight: 600}}>
								{baseFormatClean(
									calculatedValues[
										'Lifetime CO2 kilometers compared to low emission hybrid cars'
									],
								) + ' km'}
							</Text>
						</RowItem>
					</Row>
					<Row
						styleProps={{
							justifyContent: 'space-between',
							color: yellow,
							alignItems: 'center',
						}}
					>
						<RowItem styleProps={{flex: 1, flexDirection: 'row', alignItems: 'center'}}>
							<Image
								src={globe}
								style={{marginRight: '10px', width: '30px', height: '30px'}}
							/>
							<Text>Amount of times you can drive around the world</Text>
						</RowItem>
						<RowItem width="auto">
							<Text style={{textAlign: 'right', fontWeight: 600}}>
								{baseFormatClean(
									calculatedValues['The amount of times you can drive around the world'],
								) + ' times'}
							</Text>
						</RowItem>
					</Row>
				</View>
			</View>
		</PageWithHeaderAndFooter>
	);
};
